import { useNavigate } from 'react-router-dom'
import { Title } from '@telegram-apps/telegram-ui'

export default function BackHeader({ title, to = -1 as any }: { title: string; to?: any }) {
  const navigate = useNavigate()
  return (
    <div style={{ display: 'flex', alignItems: 'center', padding: '12px 16px', gap: 8 }}>
      <button
        onClick={() => navigate(to)}
        style={{
          background: 'transparent',
          border: 'none',
          fontSize: 22,
          cursor: 'pointer',
          color: 'var(--tgui--link_color, #3b82f6)',
          padding: '4px 8px',
        }}
        aria-label="Назад"
      >
        ←
      </button>
      <Title level="2" weight="2">{title}</Title>
    </div>
  )
}
